import { $$, $ } from "@utils/select";
import gsap, { ScrollToPlugin, ScrollTrigger } from "gsap/all";
import Alpine from "alpinejs";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

export default (settings) => {
  return {
    ...settings,
    bounds: {},
    currentScrollTop: 0,
    preventReveal: false,
    isScrolled: false,
    searchOpen: false,
    currentHover: "",
    listHover: false,
    timeoutList: null,
    heights: {},
    scrollTimeout: null,
    menuOpen: false,
    headerOffset: 0,
    timeoutResize: null,

    init() {
      this.$parent = $("#shopify-section-header");

      if (!this.nav.some((item) => item === this.initialSection)) {
        this.initialSection = "home";
      }

      this.currentSection = this.initialSection;
      this.$nextTick(() => {
        this.onResize();
      });

      ScrollTrigger.create({
        trigger: this.$root,
        pin: true,
        pinSpacing: false,
        end: () => document.body.scrollHeight + 100,
        onToggle: ({ isActive }) => (this.isScrolled = isActive),
      });
    },

    updateHeights() {
      clearTimeout(this.timeoutResize);
      this.timeoutResize = setTimeout(() => {
        this.onResize();
      }, 500);
    },

    // onScroll() {
    //   const scrollTop =
    //     window.pageYOffset || document.documentElement.scrollTop;

    //   if (this.searchOpen) return;

    //   if (scrollTop > this.currentScrollTop && scrollTop > this.bounds.bottom) {
    //     if (this.preventHide) return;
    //     this.isScrolled = true;

    //     requestAnimationFrame(this.hide.bind(this));
    //   } else if (
    //     scrollTop < this.currentScrollTop &&
    //     scrollTop > this.bounds.bottom
    //   ) {
    //     if (!this.preventReveal) {
    //       this.isScrolled = true;
    //       requestAnimationFrame(this.reveal.bind(this));
    //     } else {
    //       clearTimeout(this.scrollTimeout);

    //       this.scrollTimeout = setTimeout(() => {
    //         this.preventReveal = false;
    //       }, 66);

    //       requestAnimationFrame(this.hide.bind(this));
    //     }
    //   } else if (scrollTop <= this.bounds.top) {
    //     requestAnimationFrame(this.reset.bind(this));
    //     this.isScrolled = false;
    //   }

    //   this.currentScrollTop = scrollTop;
    // },

    // hide() {
    //   this.$parent.classList.add(...cHidden, ...cSticky);
    // },

    // reveal() {
    //   this.$parent.classList.add(...cSticky, ...cReveal);
    //   this.$parent.classList.remove(...cHidden);
    // },

    // reset() {
    //   this.$parent.classList.remove(...cHidden, ...cSticky, ...cReveal);
    // },

    onResize() {
      const rect = this.$parent.getBoundingClientRect();
      this.bounds.top = rect.top + window.scrollY;
      this.bounds.bottom = rect.top + window.scrollY + rect.height;
      this.bounds.height = rect.height;

      $$('[x-ref="sub"]', this.$root).forEach(($el) => {
        gsap.set($el, { display: "block", height: "auto" });
        this.heights[$el.dataset.id] = $el.offsetHeight;
        gsap.set($el, { display: "none" });
      });
    },

    toggleSearch() {
      if (this.menuOpen) this.closeMenu();
      this.searchOpen = !this.searchOpen;
      Alpine.store("global").showCover(this.searchOpen);
    },

    closeAll() {
      this.searchOpen = false;
      Alpine.store("global").showCover(false);
      this.closeMenu();
    },

    // Desktop
    onEnterSection(id) {
      clearTimeout(this.timeoutList);
      gsap.to(this.$refs.bg, {
        height: this.heights[id],
        duration: this.currentHover ? 0.5 : 0,
      });
      this.listHover = true;
      Alpine.store("global").showCover(true);
      Alpine.store("global").blockScroll(true);

      this.currentHover = id;
    },

    onEnterList() {
      clearTimeout(this.timeoutList);
      this.searchOpen = false;
    },

    onLeaveList() {
      this.timeoutList = setTimeout(() => {
        this.listHover = false;
        this.currentHover = "";
        Alpine.store("global").showCover(false);
        Alpine.store("global").blockScroll(false);
      }, 100);
    },

    // Mobile
    closeMenu() {
      Alpine.store("global").blockScroll(false);
      this.menuOpen = false;
    },

    toggleMenu() {
      if (this.searchOpen) this.toggleSearch();

      if (this.menuOpen) {
        this.closeMenu();
        return;
      }

      if (
        !this.isScrolled &&
        window.scrollY < this.bounds.top + this.bounds.height
      ) {
        gsap.to(window, {
          scrollTo: 0,
          duration: 0.1,
          onComplete: () => {
            this.headerOffset = this.bounds.top + this.bounds.height;
            this.menuOpen = true;
            Alpine.store("global").blockScroll(true);
          },
        });
        return;
      }

      Alpine.store("global").blockScroll(true);
      this.headerOffset = this.bounds.height;
      this.menuOpen = true;
    },
  };
};
